import { Mark, mergeAttributes } from '@tiptap/core';
var Underline = Mark.create({
  name: 'underline',
  addOptions: function addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 'u'
    }, {
      style: 'text-decoration',
      consuming: false,
      getAttrs: function getAttrs(style) {
        return style.includes('underline') ? {} : false;
      }
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['u', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this = this;
    return {
      setUnderline: function setUnderline() {
        return function (_ref2) {
          var commands = _ref2.commands;
          return commands.setMark(_this.name);
        };
      },
      toggleUnderline: function toggleUnderline() {
        return function (_ref3) {
          var commands = _ref3.commands;
          return commands.toggleMark(_this.name);
        };
      },
      unsetUnderline: function unsetUnderline() {
        return function (_ref4) {
          var commands = _ref4.commands;
          return commands.unsetMark(_this.name);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this2 = this;
    return {
      'Mod-u': function ModU() {
        return _this2.editor.commands.toggleUnderline();
      },
      'Mod-U': function ModU() {
        return _this2.editor.commands.toggleUnderline();
      }
    };
  }
});
export { Underline, Underline as default };